export const baseUrl = 'https://flyerskit-api-d.azurewebsites.net';

export const notificationStrings = {
	success: 'success',
	info: 'info',
	warning: 'warning',
	error: 'error',
};

export const appVariables = {
	CREATE_INVOICE: 'CREATE_INVOICE',
};

export const LOCAL_STORAGE_VARIABLES = {
	USER_PROFILE: 'USER_PROFILE',
};

export const apiUrl = {
	GET_TASK_API: '/api/Task/get-task',
};

export const OPPORTUNITY = { Id: '0065E00000LlMO1QAN' };

export const CAMPANY = { Id: 'EAA660D4-E4EE-EB11-A7AD-0050F2F16E72' };

// export const API_DOMAIN = `${process.env.REACT_APP_API_URL}/api/v${process.env.REACT_APP_VERSION}`
export const API_DOMAIN = `https://eae-clientonboarding-web-p.azurewebsites.net/api/v${process.env.REACT_APP_VERSION}`;

export const TOKEN_URL = `https://sso.sbx.edenred.io/connect/token`;
